import { ErrorHandler, inject, Injectable } from "@angular/core";
import { FrLogService } from "./fr-log.service";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    private frLogService = inject(FrLogService);

    override handleError(error: Error) {
        super.handleError(error);
        this.frLogService.logException(error);
    }
}